import React, { memo, useContext } from 'react';
import ReactMarkdown from 'react-markdown';
import { makeStyles } from '@material-ui/core/styles';
import PageContext from '../../../../../contexts/PageContext';
import { safetyCheck } from '../../../../../utils';
import fontSizeOptions from '../../../../../constants/fontSizeOptions';

const useStyles = makeStyles({
  root: {
    fontSize: (props) => props,
  },
});

const AwardItem = ({ item, fontSize }) => {
  const classes = useStyles({
    fontSize: fontSizeOptions['text-base'] + fontSize,
  });

  return (
    <div>
      <div className="flex justify-between items-center">
        <div className="flex flex-col text-left mr-2">
          <h6
            className="font-semibold"
            style={{
              fontSize: fontSizeOptions['text-base'] + fontSize,
            }}
          >
            {`${item.title} ${
              item.date && `(${new Date(item.date).getFullYear()})`
            }`}
          </h6>
          <span
            className="text-xs"
            style={{
              fontSize: fontSizeOptions['text-base'] + fontSize,
            }}
          >
            {item.awarder}
          </span>
        </div>
      </div>
      {item.summary && (
        <ReactMarkdown
          className={`markdown mt-2 ${classes.root}`}
          source={item.summary}
        />
      )}
    </div>
  );
};

const AwardsA = () => {
  const { data, heading: Heading } = useContext(PageContext);
  const { fontSize } = data.metadata.margins;

  return safetyCheck(data.awards) ? (
    <div>
      <Heading fontSize={fontSize}>{data.awards.heading}</Heading>
      <div className="grid gap-4">
        {data.awards.items.map((x) => (
          <AwardItem
            key={x.id}
            item={x}
            language={data.metadata.language}
            fontSize={fontSize}
          />
        ))}
      </div>
    </div>
  ) : null;
};

export default memo(AwardsA);
